import type { IconProps } from './types';

const ErrorSquareFilledIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M24 24H0V0H24V24ZM10.667 16.667V19.333H13.333V16.667H10.667ZM10.667 14H13.333V4.66699H10.667V14Z"
        fill={color}
      />
    </svg>
  );
};

export { ErrorSquareFilledIcon };
